"use client";

import type React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useApp } from "@/forApp/states/appState/appState";
import fetcher from "@/forApp/utils/fetcher/fetcher";
import Button from "@/shared/Buttons/Button";
import Input from "@/shared/Input/input";
import Modal from "@/shared/Modal/Modal";
import styles from "./styles.module.css";

interface FormData {
	old_password: string;
	new_password: string;
	new_password_confirmation: string;
}

const PasswordChangeModal: React.FC = () => {
	const { delModal, addNotification } = useApp();
	const [loading, setLoading] = useState(false);

	const { control, handleSubmit, reset } = useForm<FormData>({
		defaultValues: {
			old_password: "",
			new_password: "",
			new_password_confirmation: "",
		},
	});

	const closeModal = () => {
		reset();
		delModal();
	};

	const onSubmit = async (data: FormData) => {
		try {
			setLoading(true);

			// Check if passwords match
			if (data.new_password !== data.new_password_confirmation) {
				addNotification({
					text: "Новые пароли не совпадают",
					type: "error",
				});
				return;
			}

			const formData = new FormData();
			formData.append("old_password", data.old_password);
			formData.append("new_password", data.new_password);
			formData.append(
				"new_password_confirmation",
				data.new_password_confirmation,
			);

			await fetcher("POST", "/personal/change-password?_method=PATCH", {
				body: formData,
			});

			closeModal();

			// Show success notification
			addNotification({
				text: "Пароль успешно изменен",
				type: "success",
			});
		} catch (error) {
			console.error("Error changing password:", error);
			addNotification({
				text: "Ошибка при смене пароля",
				type: "error",
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal title="Изменить пароль">
			<div className={styles.modalContent}>
				<form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
					<div className={styles.formField}>
						<Input
							name="old_password"
							control={control}
							rules={{ required: true }}
							type="password"
							placeholder="Введите старый пароль"
						/>
					</div>
					<div className={styles.formField}>
						<Input
							name="new_password"
							control={control}
							rules={{ required: true }}
							type="password"
							placeholder="Введите новый пароль"
						/>
					</div>
					<div className={styles.formField}>
						<Input
							name="new_password_confirmation"
							control={control}
							rules={{ required: true }}
							type="password"
							placeholder="Повторите новый пароль"
						/>
					</div>

					<div className={styles.buttonsContainer}>
						<Button
							text={loading ? "Отправка..." : "Сохранить"}
							color="gray"
							isLoading={loading}
							type="submit"
							className={styles.submitButton}
						/>
					</div>
				</form>
			</div>
		</Modal>
	);
};

export default PasswordChangeModal;
